import { Injectable, inject, computed } from '@angular/core';
import { shareReplay } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';
import { AppConfigService } from '../../app.config.service';
import { ThemeService } from '../../core/services/theme.service';
import { TimerTypeEnum } from '../../theme/enums/timer-type.enum';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class SessionTimerService {
  private readonly authService = inject(AuthService);
  private readonly appConfig = inject(AppConfigService);
  private readonly themeService = inject(ThemeService);

  private readonly rawSeconds$ = this.authService.timeToExpiration$.pipe(
    shareReplay({ bufferSize: 1, refCount: true })
  );
  readonly rawSeconds = toSignal(this.rawSeconds$, { initialValue: 0 });
  readonly secondsForUi = computed(() => {
    const seconds = this.rawSeconds();
    const theme = this.themeService.themeSig();
    if (theme.timerType === TimerTypeEnum.nav) return seconds;
    return seconds <= this.appConfig.secondsToShowSessionInfo() ? seconds : 0;
  });
}
